/**
 * Проверка дубликата email/phone в базе ЧК
 * @param {Object} axios - инстанс axios
 * @param {Object} params - параметры для проверки
 * @param {string} [params.email] - email для проверки
 * @param {string} [params.phone] - телефон для проверки
 * @returns {Promise<{found: boolean, field: 'email'|'phone'|'email_phone'|null}>}
 */
export async function checkDuplicateEmailPhone(axios, { email, phone }) {
  const params = {}

  const trimmedEmail = (email || '').trim()
  const trimmedPhone = (phone || '').trim()

  if (trimmedEmail) params.EMAIL = trimmedEmail
  if (trimmedPhone) params.PHONE = trimmedPhone.replace(/\D/g, '')

  if (!trimmedEmail && !trimmedPhone) {
    return { found: false, field: null }
  }

  try {
    const response = await axios.get('/CheckByEmailMobile', { params })

    if (response.data?.result === 'SUCCESS') {
      return { found: false, field: null }
    }

    const error = response.data?.error

    if (error === 'FOUND_EMAIL_PHONE') {
      return { found: true, field: 'email_phone' }
    }
    if (error === 'FOUND_EMAIL') {
      return { found: true, field: 'email' }
    }
    if (error === 'FOUND_PHONE') {
      return { found: true, field: 'phone' }
    }

    return { found: false, field: null }
  } catch (error) {
    console.error('Ошибка проверки дубликата:', error)
    return { found: false, field: null }
  }
}
